export const faqExperienceData = {
  id: 'faq-items',
  className: 'panel d-flex align-items-center',
  mainContent: {
    id: 0,
    header: 'JetSuite Experiences',
    content:
      "Here are answers to a few of our most frequently asked questions. Don't see what you're looking for?",
    link: {
      url: 'mailto:embark@jetsuite.com',
      label: 'Contact Us'
    }
  },
  faqItems: [
    {
      id: 1,
      header:
        'What’s the difference between a travel agent and a travel advisor?',
      content: [
        'Travel agents are order takers – they basically do what you ask. Travel Advisors are thoughtful, strategic' +
          ' collaborators that work with you to enhance your personal life. Like a financial planner who first' +
          ' understands your needs, desires and expectations before professing advice, an experienced travel advisor' +
          ' will learn your preferences and passion points and pair that with their strong relationships around the' +
          ' world to create the most tailored travel experience for you, weaved with value and meaning.'
      ]
    },

    {
      id: 2,
      header: 'How do they do it?',
      content: [
        'Top travel advisors first take the time to understand you as a person – what are your goals? What excites' +
          ' you? What kind of places do you like, and why? What kind of places don’t you like, and why? After' +
          ' understating your wishes, they will profile anyone else traveling with you on a particular trip, and' +
          ' therein begins the art. A great travel advisor will balance everyone’s interests and attention spans and' +
          ' pepper in the right kinds of activities along the way, carefully choosing the right guides, the right' +
          ' restaurants and the right level of immersive programming. They have a Rolodex of personal contacts with' +
          ' executives at hotels they book, and to make the impossible possible, they work with local partners around' +
          ' the globe who are hyper-connected to make the impossible, yours. Whether it is giving you private' +
          ' after-hours access to a museum or pairing your child in a local chess tournament, or even a meeting with' +
          ' the Pope – a travel advisor can offer you incredible depth by leveraging their tight relationships.'
      ]
    },
    {
      id: 3,
      header: 'How does working with an advisor benefit you?',
      content: [
        'With each trip, your advisor gets to know you better, so the more your advisor gets to know you, the more' +
          ' they can create amazing experiences and memories that will last a lifetime. While you can just have your' +
          ' assistant order an advisor to book a particular hotel over certain dates, you will get the most out of' +
          ' your advisor by taking time to have an introductory call. Over time you’ll find that not only do you save' +
          ' time – and oftentimes money – but you’ll get access to experiences you wouldn’t even think possible or' +
          ' plausible on your own. Often times, clients tell their advisors that the biggest value is by trying' +
          ' places, hotels and activities they might not have considered before.'
      ]
    },

    {
      id: 4,
      header: 'Are there people who shouldn’t use an advisor?',
      content: [
        'Some people like to do things themselves and would prefer to call hotels, car services and arrange tour' +
          ' guides on their own, including all the follow-up confirmations. Advisors, of course, manage the entire' +
          ' trip, so if for example, you change your arrival, by letting your advisor know they can change any of your' +
          ' plans that are affected. In addition, advisors work with you collaboratively, listening to your ideas and' +
          ' either trying to make them better or based on their experience, suggest alternative options.'
      ]
    },

    {
      id: 5,
      header: 'Why did JetSuite partner with Embark?',
      content: [
        'Embark is part of the Virtuoso network of over 350 travel agencies and 17,000 travel advisors that sell' +
          ' more than $25 billion in luxury travel annually. Because of this volume, clients enjoy benefits such as' +
          ' confirmed upgrades, complimentary breakfasts, welcome gifts, and late check-out at over 1,000 preferred' +
          ' hotels worldwide – but that’s just the starting point. Embark is an affiliate of Ovation Travel, which on' +
          ' its own generated $1.16 billion in travel sales and was ranked by Travel Weekly as the 20th largest in the' +
          ' United States. Embark is led by managing director Jack Ezon, a multi-year member of Travel + Leisure’s' +
          ' A-List, who as president of Ovation Vacations, built its luxury travel business from scratch to $400' +
          ' million.',
        'Embark brings the buying power and clout of Virtuoso and Ovation, along with a team of 30 travel advisors' +
          ' and $50 million in sales who specialize in the highest levels of customized travel, including private' +
          ' access and unique experiences.' +
          'Because they work as a team, Embark brings to JetSuite the expertise to create memorable, highly' +
          ' personalized trips. In addition to personal relationships, Embark brings to JetSuite customers preferred' +
          ' partner benefits with top luxury brands such as Four Seasons, The Ritz-Carlton, Rosewood, Relais &' +
          ' Chateau, Dorchester Collection, Peninsula Hotels, Mandarin Oriental, Belmond and others.'
      ]
    },
    {
      id: 6,
      header:
        'Are there limits to the types of trip JetSuite Experiences by Embark can assist me with?',
      content: [
        'As told by Jack Ezon to Bloomberg:',
        'Sometimes, romantic gestures come when you least expect them. For one New York power couple—he’s a real' +
          ' estate investor and she’s a fashion designer—it arrived on her 40th birthday. They’d planned a trip' +
          ' to Ocean Club in the Bahamas (recently rebranded as a Four Seasons property), where they vacation' +
          ' regularly. But the routine was broken when their private jet veered course and flew to nearby Musha' +
          ' Island.',
        'Arriving at that resort, owned by magician David Copperfield, was only the first surprise.' +
          '“She thought it was just her and her husband taking a vacation,” explains Ezon, who planned the getaway. But when they stepped off the plane, all these people were at the dock, screaming: “Surprise!”' +
          'It took her a couple of minutes to get over the shock and start recognizing faces,” says Ezon, but the crowd included family and friends from all walks of life, some of whom she hadn’t seen in decades.' +
          '“We flew people in from Atlanta, Los Angeles, and all over the place, including some of her oldest' +
          ' friends from elementary school that she never gets to see and some close friends that had recently moved across the country.”',
        'For four days, the group had private run of the island resort. There was a treasure hunt with clues' +
          ' informed by the birthday girl’s likes and dislikes, a game show riff on This is Your Life, “Beach Olympics” featuring her favorite sports, meals by her favorite chef (who flew in for the occasion), and a movie montage of well-wishes and memories from those in attendance. ',
        '“The resort sprinkles magic into the experience in all sorts of ways,” says Ezon, who adds that the personalized flick played on a movie screen that seemingly appeared out of nowhere.' +
          '“The whole weekend was about her,” he says. “She was totally blown away.'
      ]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/components/FAQ/faq-experience-data.js